<label class="wrapper" [class.disabled]="isDisabled">
    <input type="checkbox"
         [checked]="value"
         [disabled]="isDisabled"
         (change)="toggle()"/>
        <span class="toggle" [class.active]="value">
            <span class="toggle-track {{ customClass }}"></span>
            <span class="toggle-slider {{ customClass }}"></span>
        </span>
        <span class="label">{{ label }}</span><span *ngIf="isRequired" class="required"></span>
</label>
